import { useFormikContext } from "formik"
import * as React from "react"
import { useCallback } from "react"

import Button from "../../../design-system/button"
import { isEmpty } from "../../../utils/types"

interface SubmitButtonProps<T> {
  onError: (values: T, errorMessage: string) => void
  onClick?: (values: T) => void
  children?: React.ReactNode
}
function SubmitButton<T>({
  onClick,
  onError,
  children = "Submit",
}: SubmitButtonProps<T>) {
  const { values, handleSubmit, isSubmitting, validateForm } =
    useFormikContext<T>()

  const handleClick = useCallback(async () => {
    onClick?.(values)
    const errors = await validateForm()
    if (!isEmpty(errors)) {
      onError(values, `[bad-input] ${Object.keys(errors).join(", ")}`)
    }
    handleSubmit()
  }, [handleSubmit, onClick, onError, validateForm, values])

  return (
    <Button
      type="button"
      fullWidth
      loading={isSubmitting}
      onClick={handleClick}
    >
      {children}
    </Button>
  )
}

export default SubmitButton
